import { CartItem, Product, TreeItem } from "../../types";
import { PRODUCT_TYPES, base_url } from "./constants";
import growl from "./growl";
import ShopService from './shop-service';
import UrlService from "./url-service";
import UiService from "./ui-service";
import CartService from './cart-service';
import _ from "lodash";
import OptionCategoryService from "./option-category-service";
import ModalService from "./modal-service";
import TreeOps from './tree-ops'
import Helper from './Helper.ts'

export default {
    canUpsell,
    upsell,
    downsell,
    reset,
    get_upsell_info,
    get cartMenu(): CartItem {
        return cartMenu;
    },
    get from_cartItem(): CartItem {
        return from_cartItem;
    },
    isInUpsell,
    getSuggestionsProduct,
    getFormulesCategory,
    createFormule,
    isSuggestionsProduct,
    isUpsellToProduct,
    getSuggestions,
    generateSuggestionsProduct,
    generateFormulesCategory,
    isFormulesOrSuggestionContainer,
    itemName,
    displayedMenuCategories,
}

function itemName(item) {
    return item.product.Upsell ? CartService.getUpselledItemName(item) : item.product.dn;
}

function displayedMenuCategories(item) {
    if (!item.product.Upsell) {
        return item.MenuItems;
    } else {
        let category = {
            MenuCategoryItems: [ {
                qty: 1,
                OptionGroups: null,
                MenuItems: null,
                product: item.product,
                fId: item.fid,
                pId: item.pId,
                price: item.price,
            } ],
        };
        return [item.MenuItems[0], category, ...item.MenuItems.slice(1)];
    }
}


function isFormulesOrSuggestionContainer(product) {
    return isSuggestionsProduct(product) || getFormulesCategory()?.id == product.id;
}

function getSuggestions() {
    let menu = getSuggestionsProduct();
    if (!menu?.av) {
        return [];
    }
    let suggestions = [];
    for(let i in menu?.categories[0].menuCompos) {
        let menuCompo = menu?.categories[0].menuCompos[i]
        if (menuCompo.product.av) {
            suggestions.push(menuCompo);
        }
    }
    return suggestions;
}

function getFormulesCategory() {
    let shop = ShopService.shop;
    for(let child of shop.productTree.childs) {
        if (child.product.Upsell && child.product.ty == PRODUCT_TYPES.Category) {
            return child.product;
        }
    }
    return null;
}

function generateFormulesCategory() {
    let item = TreeOps.createIn(ShopService.shop.productTree, 'Formules Upsell', PRODUCT_TYPES.Category);
    item.product.Upsell = true;
    item.product.av = 0;

    return TreeOps.saveProduct(item).then(item => item.product);
}

function isSuggestionsProduct(product: Product) {
    return Helper.isSuggestionsProduct(product, ShopService.shop);
}

function isUpsellToProduct(product) {
    return product.av && product.Upsell && product.ty == PRODUCT_TYPES.Menu && !isSuggestionsProduct(product);
}

function getSuggestionsProduct() {
    // returns a Menu which is Upsell and at the root of catalog
    let shop = ShopService.shop;
    if (!shop) {
        return null;
    }
    for(let child of shop.productTree.childs) {
        if (child.product.Upsell && child.product.ty == PRODUCT_TYPES.Menu) {
            return child.product;
        }
    }
    return null;
}

function createFormule(inItem) {
    let newItem = TreeOps.createIn(inItem, 'Formule', PRODUCT_TYPES.Menu);
        return TreeOps.saveProduct(newItem).then(item => {
            var cat = {
                CategoryId: null,
                DefaultName: 'Produit principal',
                MenuId: item.product.id,
                // treeItem: treeItem,
                menuCompos: [],
                MenuCategoryId: null,
                ChoicesNumber: 1,
                MinChoicesNumber: 1,
            }
            item.product.categories.push(cat);
            return TreeOps.saveMenuCategories(item.product).then(product=>newItem);
        });
}

function generateSuggestionsProduct() {
    let item = TreeOps.createIn(ShopService.shop.productTree, 'Suggestions', PRODUCT_TYPES.Menu);
    item.product.Upsell = true;
    item.product.av = 0;

    return TreeOps.saveProduct(item).then(item => {
        var cat = {
            CategoryId: null,
            DefaultName: 'Produits à suggérer',
            MenuId: item.product.id,
            // treeItem: treeItem,
            menuCompos: [],
            MenuCategoryId: null,
            ChoicesNumber: 1,
            MinChoicesNumber: 1,
        }
        item.product.categories.push(cat);
        return TreeOps.saveMenuCategories(item.product).then(menu => item.product)
    });
}

function canUpsell(cartItem: CartItem) {
    if (!cartItem.product.upsell_to) {
        return false;
    }
    let menu = ShopService.shop.products[cartItem.product.upsell_to];
    if (!menu || !menu.av) {
        return false;
    }
    return true;
}

let cartMenu = null, from_cartItem = null;
function check_upsell(cartItem: CartItem) {
    if (!cartItem.product.upsell_to) {
        growl.error('upsell_to is null');
        throw 'upsell_to is null'
    }
    let menu = ShopService.shop.products[cartItem.product.upsell_to];
    if (!menu) {
        growl.error('menu not found')
        throw 'menu not found'
    }
    if (!menu.Upsell) {
        growl.error('menu ' + menu.dn +' is not upsell')
        throw 'menu ' + menu.dn +' is not upsell'
    }
    if (!menu.categories[0]) {
        growl.error('menu vide')
        throw 'menu vide'
    }
    if (menu.categories[0].ChoicesNumber != 1) {
        growl.error('category needs more than 1 product')
        throw 'category needs more than 1 product'
    }
    let menuCompo = menu.categories[0].menuCompos.find(compo => compo.ProductId == cartItem.product.id);
    if (!menuCompo) {
        growl.error('product not found in menu');
        throw 'product not found in menu'
    }
    if (menu.ty != PRODUCT_TYPES.Menu) {
        growl.error('upsell is not a menu');
        throw 'upsell is not a menu'
    }
    return menuCompo;
}
function upsell(cartItem: CartItem) {
    let menuCompo = check_upsell(cartItem);
    let menu = ShopService.shop.products[cartItem.product.upsell_to];
    reset()

    cartMenu = CartService.itemToCartItem({product: menu, qty: cartItem.qty });
    from_cartItem = cartItem;
    let categoriesCarts = OptionCategoryService.getCategoriesCarts(menu.categories, cartMenu);
    let defaultCompoCartItem = {
        product: cartItem.product,
        pId: menuCompo.ProductId,
        fId: menuCompo.FinalProductId,
        qty: 1,
        price: cartItem.product.dp,
        // joinPrices: this.category.joinPrices,
        OptionGroups: cartItem.OptionGroups,
    }
    CartService.addToCart(categoriesCarts[menu.categories[0].MenuCategoryId], defaultCompoCartItem);
    // UiService.selectItem(categoriesCarts[menu.categories[0].MenuCategoryId], defaultCompoCartItem, true);
    // et si le menu n'est pas dans le ProductTree ?
    UrlService.go({name:'formule',params:{ ShopId: ShopService.shop.ShopId,pid: cartItem.pId }});
    ModalService.dismiss();
}

function reset() {
    // reset is called by CartService after an item has been added to cart
    // reset cartMenu and from_cartItem before calling itemToCartItem()
    cartMenu = from_cartItem = null;
}

function downsell() {
    window.history.back();
    UrlService.go({name:'carte',params:{tid: from_cartItem.parent.tid}});
    UiService.go(CartService.cart, from_cartItem);
    reset();
}

function get_upsell_info(cartItem: CartItem) {
    let pId = cartItem.product.upsell_to;
    let menu = ShopService.shop.products[pId];
    let catDescr = menu?.categories.slice(1).map(cat => (cat.ChoicesNumber * cartItem.qty) + ' ' + cat.DefaultName).join(' et ');
    let msg;
    msg = catDescr + ' en plus pour ' + ShopService.prix(""+(menu?.dp) * cartItem.qty);
    msg = '+ ' + menu.dn + ' pour ' + ShopService.prix(""+(menu?.dp) * cartItem.qty);
    msg = '<i class="fa fa-arrow-up"></i> Upgradez en ' + menu.dn
    msg = '<i class="fa fa-arrow-up"></i> ' + menu.dn
    if (menu.dp) {
        msg += ' pour <span class="whitespace-nowrap">' + ShopService.prix(""+(menu?.dp) * cartItem.qty) + '</span>';
    }
    return msg
}

function isInUpsell(product: Product, menuId) {
    return product.upsell_to && product.upsell_to == menuId;
}